import { Button, CloseIcon, Modal } from 'components';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginNotificationContainer } from './Auth.style';
import useWindowDimensions from 'components/Dimention';
import { swipeModalWidth } from 'utils/helper';
import SwipeableEdgeDrawer from 'components/SwipeableDrawer';

export default function LoginNotification({
  isLoginNotificationOpen,
  handleUpdateModal,
}) {
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(isLoginNotificationOpen);
  }, [isLoginNotificationOpen]);

  const handleGetContent = () => {
    return (
      <LoginNotificationContainer>
        {!isSmallScreen && <CloseIcon
          customStyle="post-close-icon"
          onClick={() => {
            setModalOpen(false);
            handleUpdateModal();
          }}
        />}
        <div className="title">Join WafyNet to Continue</div>
        <div className="description">
          To Post, like, comment, find jobs, hire talent, and grow your business
          and network.
        </div>
        <div className="action-btn">
          <Button
            label="Log In"
            type="outlined"
            onClick={() => navigate('/login')}
          />
          <Button label="Sign Up" onClick={() => navigate('/signup')} />
        </div>
      </LoginNotificationContainer>
    );
  };

  return (
    <>
      {isSmallScreen ? (
        <SwipeableEdgeDrawer
          drawerHeight={'50%'}
          openDrawer={modalOpen}
          handleCloseDrawer={() => {
            setModalOpen(false);
            handleUpdateModal();
          }}
        >
          {modalOpen && handleGetContent()}
        </SwipeableEdgeDrawer>
      ) : (
        <Modal
          removeHeader
          content={modalOpen && handleGetContent()}
          openModal={modalOpen}
          modalchanges="loginNotificationModal"
          handleCancelModal={() => {
            setModalOpen(false);
            handleUpdateModal();
          }}
        />
      )}
    </>
  );
}
